import Controller from '../abstracts/Controller';
import 'scss-templates/t-passwordreset.scss';

export default class PasswordRecoverController extends Controller {
  static get COMPONENTS() {
    return [
      'RecommendationEngineComponent',
      'GoogleRecommendationEngineComponent',
      'ShowPasswordComponent',
    ];
  }
}
